export interface ISolarAccountViewUtility {
  utilityId: number;
  utilityCode: string;
  utilityName: string;
}

export class SolarAccountViewUtility implements ISolarAccountViewUtility {
  utilityId: number;
  utilityCode: string;
  utilityName: string;
}
